:host {
	flex-grow: 1;
}

span {
	/* Position */
	position: relative;
	display: block;
	background-color: rgba(0, 0, 0, 0.10);
	overflow: hidden;
	height: 100%;
	width: 100%;
	border-radius: 5px;
}

span::after {
	content: '';
	position: absolute;
	animation: wave 2s linear 0.5s infinite;
	background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.08), transparent);
	transform: translateX(-100%);
	bottom: 0;
	left: 0;
	right: 0;
	top: 0;
}

@keyframes wave {
	to {
		transform: translateX(100%)
	}
}